import { Injectable } from '@angular/core';

import { NavigationRoute } from '../constants/constants';
import { RegWorkflowEnum, TestTypeEnum } from '../dtos/enum';
import { TestSessionForRegistrationDto } from '../dtos/dto';

@Injectable({
  providedIn: 'root'
})
export class RegWorkflowMappingService {

  private regPaths = NavigationRoute.REGISTRATION;

  private regWorkFlowMap: Map<RegWorkflowEnum, string[]> = new Map([
    [RegWorkflowEnum.CELPIP, [
      this.regPaths.proofOfIdentity,
      this.regPaths.scoreReport,
      this.regPaths.testSummary,
      this.regPaths.studyMaterials,
      this.regPaths.orderSummary,
      this.regPaths.orderComplete
    ]],
    [RegWorkflowEnum.CAEL, [
      this.regPaths.proofOfIdentity,
      this.regPaths.scoreReport,
      this.regPaths.testSummary,
      this.regPaths.studyMaterials,
      this.regPaths.orderSummary,
      this.regPaths.orderComplete
    ]],
    [RegWorkflowEnum.WEB_DELIVERY, [
      this.regPaths.proofOfIdentity,
      this.regPaths.photoUpload,
      this.regPaths.scannedDocumentUpload,
      this.regPaths.scoreReport,
      this.regPaths.testSummary,
      this.regPaths.studyMaterials,
      this.regPaths.orderSummary,
      this.regPaths.orderComplete
    ]],
    [RegWorkflowEnum.CAEL_SAFT, [
      this.regPaths.proofOfIdentity,
      this.regPaths.testSummary,
      this.regPaths.studyMaterials,
      this.regPaths.orderSummary,
      this.regPaths.orderComplete
    ]],
  ]);

  constructor(
  ) { }

  getRegWorkFlow(testSessionInformation: TestSessionForRegistrationDto): RegWorkflowEnum {
    if (testSessionInformation.testTypeId === TestTypeEnum.SAFT) {
      return RegWorkflowEnum.CAEL_SAFT;
    }

    if (testSessionInformation.isWebDelivery) {
      return RegWorkflowEnum.WEB_DELIVERY;
    }

    return RegWorkflowEnum.CELPIP;
  }

  getNextStepNew(workflow: RegWorkflowEnum, currentStep: string): string {
    if (this.regWorkFlowMap.has(workflow)) {
      const regWorkFlow = this.regWorkFlowMap.get(workflow);
      let index = regWorkFlow.findIndex(x => x === currentStep);
      if (index < regWorkFlow.length - 1) {
        index++;
      }
      return "/registration/" + regWorkFlow[index];
    }
    return "404";
  }

}
